<svg:g [attr.visibility]="visible && isActiveLayerValid ? 'visible' : 'collapse'">
    <ng-content></ng-content>
</svg:g>
